export const baseApi: string = import.meta.env.MODE == 'test' ? `${import.meta.env.VITE_FullApiUrl}${import.meta.env.VITE_BaseUrl}` : `${import.meta.env.VITE_BaseUrl}`;
